import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { ButtonGroup, Button, Modal, Glyphicon, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import AddZlecenieModal from './AddZlecenie';
import UpdateZlecenieModal from './UpdateZlecenie';
import WydrukKlientModal from './WydrukKlient';
import WydrukMagazynModal from './WydrukMagazyn';
import { login, logout, isLoggedIn} from '../../utils/AuthService';

var Zlecenia = React.createClass({

	getInitialState: function() {
		return {
			data: null,
			selectedZlecenieIds: [],
			showAddModal: false,
			showUpdateModal: false,
			showWydrukKlientModal: false,
			showWydrukMagazynModal: false,
			showZrealizowane: false
		}
    },

	componentDidMount: function() {
		this.refreshTable();
	},

	render: function() {

		var selectedIds = this.state.selectedZlecenieIds;
		var selectedCount = selectedIds.length;
		var singleOnly = selectedCount !== 1;
		var noneSelected = selectedCount === 0;
		var selectRowProp = {
			mode: "checkbox",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect,
			onSelectAll: this.onSelectAll,
			selected: selectedIds
		};

		if(!isLoggedIn()){
			return (<div></div>);
		};

		var filteredData = this.state.data;
		if (filteredData && !this.state.showZrealizowane) {
			filteredData = filteredData.filter(function(z) { return !z.czyZrealizowane; });
		}

		var printKlientLabel = selectedCount > 1 ? 'Drukuj - klient (' + selectedCount + ')' : 'Drukuj - klient';
		var printMagLabel = selectedCount > 1 ? 'Drukuj - magazyn (' + selectedCount + ')' : 'Drukuj - magazyn';
		var delLabel = selectedCount > 1 ? 'Usuń (' + selectedCount + ')' : 'Usuń';
		var zrealLabel = selectedCount > 1 ? 'Oznacz jako zrealizowane (' + selectedCount + ')' : 'Oznacz jako zrealizowane';
		var niezrealLabel = selectedCount > 1 ? 'Cofnij realizację (' + selectedCount + ')' : 'Cofnij realizację';

		return (
			<div>
				<div className="row">
					<div className="col-sm-5">
						<ButtonGroup className="m-10">
							<Button bsStyle="primary" onClick={this.openAddModal}><Glyphicon glyph="plus" /> Dodaj zlecenie</Button>
							<Button bsStyle="warning" disabled={singleOnly} onClick={this.openUpdateModal}><Glyphicon glyph="refresh" /> Aktualizuj</Button>
							<Button bsStyle="danger" disabled={noneSelected} onClick={this.onDeleteBtnClicked}><Glyphicon glyph="trash" /> {delLabel}</Button>
						</ButtonGroup>
					</div>
					<div className="col-sm-4">
						<ButtonGroup className="m-10">
							<Button bsStyle="primary" disabled={noneSelected} onClick={this.openWydrukKlientModal}><Glyphicon glyph="print" /> {printKlientLabel}</Button>
							<Button bsStyle="primary" disabled={noneSelected} onClick={this.openWydrukMagazynModal}><Glyphicon glyph="print" /> {printMagLabel}</Button>
						</ButtonGroup>
					</div>
					<div className="col-sm-3">
						<Button bsStyle={this.state.showZrealizowane ? 'info' : 'default'} onClick={this.toggleZrealizowane}>
							<Glyphicon glyph="eye-open" /> {this.state.showZrealizowane ? 'Ukryj zrealizowane' : 'Pokaż zrealizowane'}
						</Button>
					</div>
				</div>


				<BootstrapTable data={filteredData}
					trClassName={this.rowClassFormat}
					hover={true}
					pagination={true}
					search={true}
					selectRow={selectRowProp}>
						<TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
						<TableHeaderColumn dataField="imie" dataSort={true}>Imię</TableHeaderColumn>
						<TableHeaderColumn dataField="nazwisko" dataSort={true}>Nazwisko</TableHeaderColumn>
						<TableHeaderColumn dataField="telefon" dataSort={true}>Telefon</TableHeaderColumn>
						<TableHeaderColumn dataField="numerListwy" dataSort={true}>Nr Listwy</TableHeaderColumn>
					  <TableHeaderColumn dataField="cena" dataSort={true}>Cena</TableHeaderColumn>
						<TableHeaderColumn dataField="zaliczka" dataSort={true}>Zaliczka</TableHeaderColumn>
						<TableHeaderColumn dataField="pozostalaDoplata" dataSort={true}>Doplata</TableHeaderColumn>
						<TableHeaderColumn dataField="uwagi" dataSort={true}>Uwagi</TableHeaderColumn>
						<TableHeaderColumn dataField="czyZrealizowane" dataSort={true}>Zrealizowane</TableHeaderColumn>
				</BootstrapTable>

				<Button bsStyle="success" disabled={noneSelected} onClick={this.onZrealizowaneBtnClicked}><Glyphicon glyph="ok" /> {zrealLabel}</Button>
				{' '}
				<Button bsStyle="default" disabled={noneSelected} onClick={this.onNiezrealizowaneBtnClicked}><Glyphicon glyph="remove" /> {niezrealLabel}</Button>

				<AddZlecenieModal parent={this} ref="addZlecenie" />
				<UpdateZlecenieModal parent={this} ref="updateZlecenie"/>
				<WydrukKlientModal parent={this} ref="wydrukKlient"/>
				<WydrukMagazynModal parent={this} ref="wydrukMagazyn"/>

			</div>
		);
	},

	onRowSelect: function(row, isSelected) {
		var ids = this.state.selectedZlecenieIds.slice();
		if (isSelected) {
			if (ids.indexOf(row.id) === -1) ids.push(row.id);
		} else {
			ids = ids.filter(function(i) { return i !== row.id; });
		}
		this.setState({ selectedZlecenieIds: ids });
	},

	onSelectAll: function(isSelected, rows) {
		var ids = isSelected ? rows.map(function(r) { return r.id; }) : [];
		this.setState({ selectedZlecenieIds: ids });
	},

	closeAddModal: function() {
		this.setState({ showAddModal: false });
		this.refs.addZlecenie.clearAddObject();
	},

	openAddModal: function() {
		this.refs.addZlecenie.clearAddObject();
		this.setState({ showAddModal: true });
	},

	closeUpdateModal: function() {
		this.setState({showUpdateModal: false});
		this.refs.updateZlecenie.clearUpdateObject();
	},

	openUpdateModal: function() {
		this.refs.updateZlecenie.fillUpdateObject();
		this.setState({showUpdateModal: true});
	},

	closeWydrukKlientModal: function() {
		this.setState({showWydrukKlientModal: false});
		this.refs.wydrukKlient.clearWydrukKlientObject();
	},

	openWydrukKlientModal: function() {
		this.refs.wydrukKlient.fillWydrukKlientObject();
		this.setState({showWydrukKlientModal: true});
	},

	closeWydrukMagazynModal: function() {
		this.setState({showWydrukMagazynModal: false});
		this.refs.wydrukMagazyn.clearWydrukMagazynObject();
	},

	openWydrukMagazynModal: function() {
		this.refs.wydrukMagazyn.fillWydrukMagazynObject();
		this.setState({showWydrukMagazynModal: true});
	},

	onDeleteBtnClicked: function() {
		var self = this;
		var ids = this.state.selectedZlecenieIds;
		if (ids.length === 0) return;
		if (ids.length > 1 && !window.confirm('Usunąć ' + ids.length + ' zleceń?')) return;
		var requests = ids.map(function(id) { return axios.delete(API_URL + '/zlecenie/' + id); });
		Promise.all(requests)
			.then(function() { self.setState({ selectedZlecenieIds: [] }); self.refreshTable(); })
			.catch(function(err) { alert("Błąd przy usuwaniu zlecenia"); console.log(err); self.refreshTable(); });
	},

	getZlecenieById: function(id) {
		for(var i in this.state.data) {
			if(this.state.data[i].id === id) {
				return this.state.data[i];
			}
		}
		return '';
	},

	onZrealizowaneBtnClicked: function() {
		var self = this;
		var ids = this.state.selectedZlecenieIds;
		if (ids.length === 0) return;
		var requests = ids.map(function(id) { return axios.put(API_URL + '/zlecenieZrealizowane/' + id); });
		Promise.all(requests)
			.then(function() { self.setState({ selectedZlecenieIds: [] }); self.refreshTable(); })
			.catch(function(err) { alert("Błąd przy oznaczaniu jako zrealizowane"); console.log(err); self.refreshTable(); });
	},

	onNiezrealizowaneBtnClicked: function() {
		var self = this;
		var ids = this.state.selectedZlecenieIds;
		if (ids.length === 0) return;
		var requests = ids.map(function(id) { return axios.put(API_URL + '/zlecenieNiezrealizowane/' + id); });
		Promise.all(requests)
			.then(function() { self.setState({ selectedZlecenieIds: [] }); self.refreshTable(); })
			.catch(function(err) { alert("Błąd przy cofaniu realizacji"); console.log(err); self.refreshTable(); });
	},


// WYDRUKI PDF Z SERWERA
	// onWydrukKlientBtnClicked: function() {
	// 	axios.put(API_URL + '/zlecenieWydrukKlient/' + this.state.selectedZlecenieId)
	// 		.then(function (response) {
	// 			this.refreshTable();
	// 		}.bind(this))
	// 		.catch(function (error) {
	// 			alert("Błąd przy generowaniu wydruku");
	// 			console.log(error);
	// 		});
	// },
	//
	// onWydrukMagazynBtnClicked: function() {
	// 	axios.get(API_URL + '/zlecenieWydrukMagazyn/' + this.state.selectedZlecenieId)
	// 		.then(function (response) {
	// 			this.pdf = response;
	// 			console.log(this.pdf);
	// 			this.openWydrukMagazynModal();
	// 		}.bind(this))
	// 		.catch(function (error) {
	// 			alert("Błąd przy generowaniu wydruku");
	// 			console.log(error);
	// 		});
	// },

	toggleZrealizowane: function() {
		this.setState({ showZrealizowane: !this.state.showZrealizowane });
	},

	rowClassFormat: function(row, rowIdx) {
		if (row.punktSprzedazy === 'Castorama') return 'punkt-castorama';
		if (row.punktSprzedazy === 'Arena') return 'punkt-arena';
		if (row.punktSprzedazy === 'Domar') return 'punkt-domar';
		return '';
	},

	refreshTable: function() {
		axios.get(API_URL + '/zlecenie')
		.then(function (zlecenia) {
			this.setState({data: zlecenia.data});
		}.bind(this));
	}
});

export default Zlecenia;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/Zlecenia.js